<script lang="ts" setup>
import { PropType } from 'vue'

import IfViewport from '@/components/common/IfViewport.vue'
import { StandingsTableRow } from '@/store/public/leagues.types'
import { formatFloat } from '@/utils/format'

defineProps({
  rows: {
    type: Array as PropType<StandingsTableRow[]>,
    required: true,
  },
})
</script>

<template>
  <div class="table-container">
    <table class="table">
      <thead>
        <tr>
          <th class="fit-content"></th>
          <th>{{ $t('leagues.labels.team') }}</th>
          <th>{{ $t('leagues.labels.city') }}</th>
          <th class="align-center">{{ $t('leagues.labels.total') }}</th>

          <IfViewport min-width="1024">
            <th class="align-center">{{ $t('leagues.labels.bonus') }}</th>
            <th class="align-center">{{ $t('leagues.labels.raw') }}</th>
            <th class="align-center">
              {{ $t('leagues.labels.games-played') }}
            </th>
            <th class="align-center">{{ $t('leagues.labels.wins') }}</th>
            <th class="align-center">{{ $t('leagues.labels.draws') }}</th>
            <th class="align-center">{{ $t('leagues.labels.losses') }}</th>
          </IfViewport>

          <IfViewport min-width="512">
            <th class="align-center">{{ $t('leagues.labels.average') }}</th>
            <th class="align-center">{{ $t('leagues.labels.best') }}</th>
            <th class="align-center">{{ $t('leagues.labels.difference') }}</th>
          </IfViewport>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(row, i) in rows" :key="`row-${i}`">
          <td class="align-right fit-content">{{ i + 1 }}.</td>
          <td>{{ row.name }}</td>
          <td>{{ row.city }}</td>
          <td class="align-center">
            {{ formatFloat(row.total_points, 0) }}
          </td>

          <IfViewport min-width="1024">
            <td class="align-center">
              {{ formatFloat(row.bonus, 0) }}
            </td>

            <td class="align-center">
              {{ formatFloat(row.total_points_raw, 0) }}
            </td>

            <td class="align-center">
              {{ formatFloat(row.match_count, 0) }}
            </td>
            <td class="align-center">
              {{ formatFloat(row.win_count, 0) }}
            </td>
            <td class="align-center">
              {{ formatFloat(row.draw_count, 0) }}
            </td>
            <td class="align-center">
              {{ formatFloat(row.loss_count, 0) }}
            </td>
          </IfViewport>

          <IfViewport min-width="512">
            <td class="align-center">
              {{ formatFloat(row.average_points_raw, 2) }}
            </td>
            <td class="align-center">
              {{ formatFloat(row.best_score, 0) }}
            </td>
            <td class="align-center">
              {{ formatFloat(row.point_difference, 0) }}
            </td>
          </IfViewport>
        </tr>
      </tbody>
    </table>
  </div>
</template>
